<script lang="ts">
    import bookmark_simple from "$lib/assets/BookmarkSimple.svg";
    import bookmark_simple_filled from "$lib/assets/BookmarkSimpleFilled.svg";

    import { popup } from "@skeletonlabs/skeleton";
    import { fade } from "svelte/transition";

    import { onMount } from "svelte";

    export let user_id: string | undefined;
    export let session_id: string | undefined;
    export let grant_id: string;
    export let doLoad: boolean = true;
    export let isChecked: boolean = false;

    $: checked = isChecked;

    async function bookmarkListener(event) {
        if (!user_id) {
            event.target.checked = false;
            return;
        }
        checked = !checked;
        let log_action = checked ? "bookmark" : "unbookmark";

        let post_resp: Response = await fetch(
            `/api/grantrec/bookmark?` +
                new URLSearchParams({
                    user_id: user_id,
                    grant_id: grant_id,
                    action: checked ? "add" : "delete",
                }),
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            },
        );
        fetch(`/api/grantrec/log`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                user_id: user_id,
                session_id: session_id,
                action: log_action,
                query: grant_id,
            }),
        });
    }

    onMount(() => {
        if (doLoad) {
            if (user_id) {
                fetch(
                    `/api/grantrec/get_bookmark?` +
                        new URLSearchParams({ user_id: user_id, grant_id: grant_id }),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                    },
                ).then((resp) => {
                    resp.json().then((result) => {
                        checked = result.results.length > 0;
                    });
                });
            }
        } else {
            checked = isChecked;
        }
    });
</script>

<div
    class="bookmark h-8 w-8 xs:mr-0 mr-3 rounded-lg transition duration-300 hover:bg-secondary-600"
    on:click|stopPropagation
>
    <button
        class="grid grid-rows-1 grid-cols-1 [&>*]:pointer-events-none"
        on:click|stopPropagation={bookmarkListener}
        use:popup={{
            event: "hover",
            target: "saveGrant-" + grant_id,
            placement: "top",
        }}
    >
        {#key checked}
            <img
                src={bookmark_simple_filled}
                class="row-span-full col-span-full opacity-{checked * 100} transition duration-300"
                alt="Bookmarked"
                transition:fade={{ duration: 300 }}
            />
        {/key}
        <img src={bookmark_simple} class="row-span-full col-span-full" alt="Not Bookmarked" />
    </button>
</div>

<div class="bg-black rounded-lg p-3 transition duration-100" data-popup="saveGrant-{grant_id}">
    <p class="text-xs text-white">
        {user_id ? (checked ? "Unsave grant" : "Save grant") : "Please login to save grants"}
    </p>
    <div class="arrow bg-black" />
</div>
